import { render } from "./submissionView.vue?vue&type=template&id=498f18c4"
import script from "./submissionView.vue?vue&type=script&lang=js"
export * from "./submissionView.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Programming\\Padmaweb\\client\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__